import { render } from "./DigitalPrPage.vue?vue&type=template&id=0efe81e8"
import script from "./DigitalPrPage.vue?vue&type=script&lang=js"
export * from "./DigitalPrPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/lbhq_agencyportal_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__